import { FaGift } from "react-icons/fa";

const GiftBoxCTA = () => {
  const handleClick = () => {
    window.open(
      "https://sobia.gumroad.com/l/lumina-reactjs-portfolio-template",
      "_blank"
    );
  };

  return (
    <div
      onClick={handleClick}
      role="button"
      aria-label="Get Lumina Template on Gumroad"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleClick()}
      style={{
        position: "fixed",
        bottom: "25px",
        right: "25px",
        background: "linear-gradient(135deg, #ec4899, #8b5cf6)",
        color: "#fff",
        padding: "12px 18px",
        borderRadius: "20px",
        boxShadow: "0 6px 15px rgba(0,0,0,0.3)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        zIndex: 99999,
        fontWeight: 500,
        transition: "transform 0.3s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <FaGift />
      <span style={{ fontSize: "14px" }}>Get This Template</span>
    </div>
  );
};

export default GiftBoxCTA;